import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicComponent } from './basic/basic.component';
import { ExperienceComponent } from './experience/experience.component';
import { PersonalComponent } from './personal/personal.component';
import { ProfessionalComponent } from './professional/professional.component';
import { DataPrivacyComponent } from './data-privacy/data-privacy.component';
import { ProfileComponent } from './profile.component';
import { LibModule } from '@ui-components/lib.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ProfileComponent,
    BasicComponent,
    ExperienceComponent,
    PersonalComponent,
    ProfessionalComponent,
    DataPrivacyComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LibModule
  ],
  exports: [
    BasicComponent,
    ExperienceComponent,
    PersonalComponent,
    ProfessionalComponent,
    DataPrivacyComponent
  ],
})
export class ProfileModule { }
